import { useQuery } from "react-query";
import { Endpoints } from "../../enums/Endpoints";
import { smartbizUrl } from "../ApiClient";
import {
  handleOpenToaster,
  toasterData,
  ErrorMessages,
} from "@amzn/rangoli-seller-desktop-utils/src/index";
import { ICustomDomainResponse } from "../../types/CustomerDomain.types";
import { QueryParams } from "../../enums/QueryParams";
const { DOMAINS, INFO } = Endpoints;
const { CUSTOM_DOMAIN_KEY } = QueryParams
const SOMETHING_WENT_WRONG = ErrorMessages["SOMETHING_WENT_WRONG"];

const useGetCustomDomain = (storeURI: string)  => {
  const { data, isLoading, error, refetch } = useQuery(
    [CUSTOM_DOMAIN_KEY],
    () => getDomain(storeURI),
    {
      enabled: storeURI?.length > 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
  return { data, isLoading, error, refetch };
};

const getDomain = async (storeURI: string): Promise<ICustomDomainResponse> => {
  try {
    const storeURILowerCase = storeURI.toLowerCase();       
    const response = await smartbizUrl.get(
      `/${DOMAINS}/${storeURILowerCase}/${INFO}`
    );
    return response.data;
  } catch (error) {
    handleOpenToaster({ ...toasterData, text: SOMETHING_WENT_WRONG });
  }
};

export default useGetCustomDomain;
